export const pick = <T extends Record<string, unknown>, K extends keyof T>(
  values: T,
  keys: K[]
): Pick<T, K> => {
  const picked = {} as Pick<T, K>;
  for (const key of keys) {
    const value = values[key];
    if (typeof value === 'boolean' || typeof value === 'number' || !!value) {
      picked[key] = value;
    }
  }
  return picked;
};
